<div class="store-card" [ngClass]="'store-card--' + colorClass">
  <!-- Icon box top-left -->
  <div class="store-card__icon-box">
    <mat-icon>{{ icon }}</mat-icon>
  </div>

  <!-- Decorative background icons -->
  <div class="store-card__bg-icon store-card__bg-icon--1">
    <mat-icon>{{ icon }}</mat-icon>
  </div>
  <div class="store-card__bg-icon store-card__bg-icon--2">
    <mat-icon>{{ icon }}</mat-icon>
  </div>

  <!-- Lingo AI badge (top-right) -->
  @if (lingoBadgeSrc) {
    <img class="store-card__lingo-badge" alt="Lingo AI" [src]="lingoBadgeSrc" />
  }

  <!-- Title and subtitle -->
  <h3 class="store-card__title">{{ title }}</h3>
  <p class="store-card__subtitle">{{ subtitle }}</p>
</div>
